const sessionKey = (organizationId: number): string =>
  `paywall_seen:${organizationId}`;

export const hasSeenPaywall = (organizationId?: number | null): boolean => {
  if (organizationId == null) return false;
  return window.sessionStorage.getItem(sessionKey(organizationId)) === 'true';
};

export const markPaywallSeen = (organizationId?: number | null): void => {
  if (organizationId == null) return;
  window.sessionStorage.setItem(sessionKey(organizationId), 'true');
};
